export const VehicleInformationMapping = {
  vehicleInformationList: 0,
  vehicleExpensesList: 1,
  vehicleAccidentList: 2,
  dieselUsageList: 3,
  vehicleMaintenanceList: 4,
  vehicleIndemnityList: 5,
};
